module.exports = __webpack_public_path__ + "img/DerAufprall8.90ef0fe7.jpg";